import { Grid, Tooltip, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  createDiagnosticsWoLoader,
  getPetDiagnosticsWoLoader,
  updateDiagnosticsWoLoader,
} from "../../../../redux/reducers/petSlice";
import { doneAtList } from "../../../../util/dropList";
import { urlToFile } from "../../../../util/function";
import { canWriteModule } from "../../../../util/roleModuleAccess";
import DiagnosticAddUpdate from "../../../CommonScreens/Diagnostic/DiagnosticAddUpdate";
import DiagnosticReport from "../../../CommonScreens/Diagnostic/DiagnosticReport";
import {
  getDiagnosticsFetchKey,
  setDiagnosticsFetchKey,
} from "../clinicPetDetailsSession";

const nameExpan = {
  type: "Select Type",
  testName: "Test Name",
  variant: "Variant",
  dueDate: "Due Date",
  remarks: "Remarks",
  doneAt: "Done At",
  sampleType: "Sample Type",
  processingTime: "Processing Time",
  modality: "Modality",
  device: "Device",
  priority: "Priority",
  status: "Status",
  collectionTime: "Collection Time *",
};

const initialValues = {
  type: "Lab",
  testName: null,
  dueDate: new Date(),
  remarks: "",
  files: [],
  price: 0,
  tax: 0,
  sampleCollected: false,
  doneAt: doneAtList?.[0]?.value,
  collectionTime: new Date(),
  priority: "Routine",
  sampleCollected: false,
};

const initialErrors = { type: false, dueDate: false, remarks: false };
const initialHelpers = { type: "", dueDate: "", remarks: "" };

const OverviewDiagnostics = ({ isBaseDetailsLoaded }) => {
  const dispatch = useDispatch();
  const canManageDashboard = canWriteModule("dashboard");
  const location = useLocation();
  const { appointment } = location.state || {};
  const [modVisible, setModVisible] = useState(false);
  const [printModVsble, setPrintModVsble] = useState(false);
  const [diagValues, setDiagValues] = useState(initialValues);
  const [diagnosticsHelpers, setDiagnosticsHelpers] = useState(initialHelpers);
  const [diagnosticsErrors, setDiagnosticsErrors] = useState(initialErrors);
  const [diagnosticsId, setDiagnosticsId] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isEditModal, setEditModal] = useState(false);
  const [fileError, setFileError] = useState(false);
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const diagnostics = useSelector((state) => state?.pet?.diagnostics);
  const services = useSelector((state) => state?.clinic?.services);
  const apntDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const { petDetails } = useSelector((state) => state?.pet);
  const role = localStorage.getItem("role");
  const petId =
    appointment?.appoinment?.petId ??
    reqDet?.appointment?.petId ??
    petDetails?.petId;

  const onApiCall = () => {
    if (!petId) return;
    dispatch(
      getPetDiagnosticsWoLoader({
        petId,
        url: "?page=1&itemSize=30",
      }),
    );
  };

  useEffect(() => {
    if (!petId || !isBaseDetailsLoaded) return;
    const fetchKey = `${petId}`;
    if (getDiagnosticsFetchKey() === fetchKey) return;
    setDiagnosticsFetchKey(fetchKey);
    dispatch(
      getPetDiagnosticsWoLoader({
        petId,
        url: "?page=1&itemSize=30",
      }),
    );
  }, [petId, dispatch, isBaseDetailsLoaded]);

  const getDiagList = () => {
    return diagnostics?.data
      ?.filter(
        (li) =>
          li?.appoinment?.appointmentId &&
          ["in progress", "pending review", "patient review"]?.includes(
            li?.status?.toLowerCase(),
          ),
        //  "completed"
      )
      ?.sort((a, b) => new Date(b?.dueDate) - new Date(a?.dueDate));
  };

  const handleModClose = (typ) => {
    if (typ === "apiSuccess") onApiCall();
    setModVisible(false);
    // setDiagValues(initialValues);
    // setDiagnosticsErrors(initialErrors);
    // setDiagnosticsHelpers(initialHelpers);
    // setEditModal(false);
    setSelectedItem(null);
    // setDiagnosticsId(null);
  };

  const getDiagnostics = () => {
    return services?.data
      ?.filter(
        (dl) => dl?.category?.toLowerCase() === diagValues?.type?.toLowerCase(),
      )
      ?.map((dl) => ({
        ...dl,
        name: dl?.serviceName,
        value: dl?.serviceName,
      }));
  };

  const getVariantsByServiceId = (servId = null) => {
    if (!servId) return [];
    const servDet = getServiceDetById(servId);
    if (servDet) {
      return servDet?.serviceVariants?.map((vnt) => ({
        ...vnt,
        name: vnt?.variantName,
        value: vnt?.variantId,
      }));
    }
    return [];
  };

  const handleChangeValues = (name, value, addObj) => {
    const reqObj = { ...diagValues, [name]: value };
    if (name === "testName") {
      reqObj.price = addObj?.price;
      reqObj.tax = addObj?.tax;
      reqObj.doneAt = addObj.doneAt;
    }
    if (name === "variant") {
      reqObj.variantId = addObj?.variantId;
      reqObj.variantName = addObj?.variantName;
    }
    if (addObj?.serviceId) {
      reqObj.serviceId = addObj?.serviceId;
      const reqVar = getVariantsByServiceId(addObj?.serviceId);
      if (reqVar?.[0]?.variantId) {
        reqObj.variantId = reqVar?.[0]?.variantId;
        reqObj.variantName = reqVar?.[0]?.variantName;
        reqObj.variant = reqVar?.[0]?.variantId;
      }
    }
    if (name === "sampleCollected" && value) {
      reqObj.dueDate = new Date();
      reqObj.collectionTime = new Date();
    }
    setDiagValues(reqObj);
    setDiagnosticsErrors({
      ...diagnosticsErrors,
      [name]:
        value?.length > 0 || typeof value === "number"
          ? false
          : name === "dueDate"
            ? false
            : name === "collectionTime"
              ? false
              : true,
    });
    setDiagnosticsHelpers({
      ...diagnosticsHelpers,
      [name]:
        value?.length > 0 || typeof value === "number"
          ? ""
          : name === "dueDate"
            ? ""
            : name === "collectionTime"
              ? ""
              : `${name === "type" ? "Type" : nameExpan?.[name]} is required`,
    });
  };

  const getServiceDetById = (servId, vrntId = null) => {
    const reqServ = services?.data?.find((ser) => ser?.serviceId === servId);
    if (vrntId) {
      return (
        reqServ?.serviceVariants?.find((vnt) => vnt?.variantId === vrntId) ?? {}
      );
    }
    return reqServ;
  };

  const onUploadFile = (e) => {
    const fileList = e?.target?.files;
    let fileLists = diagValues?.files?.length > 0 ? [...diagValues?.files] : [];

    const readFiles = Array.from(fileList).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [
            ...fileLists,
            {
              file: file,
              previewUrl: reader.result,
            },
          ];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });

    Promise.all(readFiles)
      .then(() => setDiagValues({ ...diagValues, files: fileLists }))
      .catch((error) => console.error("Error reading files: ", error));
  };

  const handleImageRemove = (ind) => {
    const reqFiles = diagValues?.files?.filter((fl, i) => i !== ind);
    setDiagValues({ ...diagValues, files: reqFiles });
  };

  const handleSave = async () => {
    //handle validation
    const err = {};
    const hlp = {};
    if (!diagValues?.testName) {
      err.testName = true;
      hlp.testName = "Test Name is required";
    }
    // if (!diagValues?.variant) {
    //   err.variant = true;
    //   hlp.variant = "Varinat is required";
    // }
    if (!diagValues?.dueDate) {
      err.dueDate = true;
      hlp.dueDate = "Due Date is required";
    }
    if (!diagValues?.collectionTime) {
      err.collectionTime = true;
      hlp.collectionTime = "Collection Time is required";
    }
    if (Object.keys(err).length > 0) {
      setDiagnosticsErrors({ ...diagnosticsErrors, ...err });
      setDiagnosticsHelpers({ ...diagnosticsHelpers, ...hlp });
      return;
    }
    // const appointmentId = appointment?.appoinment?.appointmentId;
    const form = new FormData();
    if (
      (selectedItem?.appoinment?.appointmentId ||
        apntDet?.appointment?.appointmentId) &&
      (diagValues?.sampleCollected || selectedItem?.sampleCollected === "Y")
      // apntDet?.appointment?.appointmentDate ===
      // moment(new Date(diagValues?.dueDate)).format("YYYY-MM-DD")
    ) {
      form.append(
        "appId",
        selectedItem?.appoinment?.appointmentId ||
          apntDet?.appointment?.appointmentId,
      );
    }
    form.append("type", diagValues?.type);
    form.append("testName", diagValues?.testName);
    form.append("doneAt", diagValues?.doneAt);
    form.append("sampleCollected", diagValues?.sampleCollected);
    form.append("priority", diagValues?.priority);
    form.append("price", Number(diagValues?.price ?? 0));
    form.append("tax", Number(diagValues?.tax ?? 0));
    form.append(
      "dueDate",
      moment(new Date(diagValues?.dueDate)).format("YYYY-MM-DD"),
    );
    form.append("remark", diagValues?.remarks);
    if (diagValues?.serviceId) {
      form.append("serviceId", diagValues?.serviceId);
    }
    if (diagValues?.variant ?? diagValues?.variantId) {
      form.append("variantId", diagValues?.variant ?? diagValues?.variantId);
    }
    if (diagValues?.variantName) {
      form.append("variantName", diagValues?.variantName);
    }
    if (
      isEditModal
        ? selectedItem?.dueDate !==
            moment(new Date(diagValues?.dueDate)).format("YYYY-MM-DD") &&
          apntDet?.appointment?.appointmentDate ===
            moment(new Date(diagValues?.dueDate)).format("YYYY-MM-DD")
        : apntDet?.appointment?.appointmentDate ===
          moment(new Date(diagValues?.dueDate)).format("YYYY-MM-DD")
    ) {
      form.append("addToBilling", true);
    }

    if (diagValues?.sampleCollected) {
      if (diagValues?.files?.length > 0) {
        const filePromises = diagValues?.files?.map(async (fle) => {
          if (fle?.file) {
            return fle?.file; // Local File
          } else {
            return await urlToFile(fle?.previewUrl); // Remote File
          }
        });
        const finalFiles = await Promise.all(filePromises);
        finalFiles?.forEach((file) => {
          form.append("file", file);
        });
      }
      if (
        diagValues?.files?.length === 0 ||
        (!diagValues?.files && selectedItem?.file?.length)
      ) {
        form.append("fileDelete", true);
      }
      form.append(
        "collectionTime",
        moment(new Date(diagValues?.collectionTime)).format("HH:mm"),
      );
    }

    let isFile = false;
    if (
      apntDet?.diagnostics?.find((dia) => dia?.diagonosticId === diagnosticsId)
        ?.status === "Completed"
    ) {
      isFile = true;
    }
    if (!diagValues?.sampleCollected) {
      form.append("status", "Scheduled");
    }
    if (diagValues?.sampleCollected) {
      if (diagValues?.files?.length > 0) {
        form.delete("status");
        form.append("status", "Pending Review");
      } else {
        form.delete("status");
        form.append("status", "In progress");
      }
    }
    if (
      selectedItem?.status?.toLowerCase() === "pending review" &&
      role === "ROLE_DOCTOR"
    ) {
      form.delete("status");
      form.append("status", "Completed");
    }
    if (isFile) {
      form.delete("status");
      form.append("status", "Completed");
    }
    if (!isEditModal) {
      dispatch(
        createDiagnosticsWoLoader({
          appointmentId:
            selectedItem?.appoinment?.appointmentId ||
            apntDet?.appointment?.appointmentId,
          form,
          formData: true,
        }),
      ).then((res) => {
        if (res?.payload?.status === 200) {
          onApiCall();
          handleModClose();
          setFileError(false);
        }
      });
    } else {
      const metaUpdate = { diagnosticsId, form };
      dispatch(updateDiagnosticsWoLoader(metaUpdate)).then((res) => {
        if (res?.payload?.status === 200) {
          onApiCall();
          handleModClose();
          setFileError(false);
        }
      });
    }
  };

  const handleEditModal = (diagnostics) => {
    setSelectedItem(diagnostics);
    if (diagnostics?.status?.toLowerCase() === "completed") {
      setPrintModVsble(true);
    } else {
      setModVisible(true);
    }
    // setDiagnosticsId(diagnostics?.diagonosticId);
    // setSelectedItem(diagnostics);
    // const reqDia = getServiceDetById(diagnostics?.serviceId);
    // const [hour, min] =
    //   diagnostics?.collectionTime?.length > 0
    //     ? diagnostics?.collectionTime?.split(":")
    //     : ["00:00"];

    // const reqObj = {
    //   type: diagnostics?.type,
    //   testName: diagnostics?.testName,
    //   remarks: diagnostics?.remark,
    //   dueDate: diagnostics?.dueDate,
    //   price: reqDia?.servicePrice ?? reqDia?.sellPrice ?? 0,
    //   tax: reqDia?.tax ?? 0,
    //   serviceId: reqDia?.serviceId,
    //   files: diagnostics?.file?.map((fle) => ({ previewUrl: fle })),
    //   doneAt: diagnostics?.doneAt,
    //   sampleCollected: diagnostics?.sampleCollected === "Y",
    //   priority: diagnostics?.priority,
    //   status: diagnostics?.status,
    //   collectionTime: new Date(
    //     new Date().setHours(hour ? hour : 0, min ? min : 0),
    //   ),
    // };
    // if (diagnostics?.variantId) {
    //   reqObj.variantId = diagnostics?.variantId;
    //   const vnts = getVariantsByServiceId(
    //     reqDia?.serviceId ?? diagnostics?.serviceId,
    //   );
    //   if (vnts?.length > 0) {
    //     const reqVar = vnts?.find(
    //       (vt) => vt?.variantId === diagnostics?.variantId,
    //     );
    //     if (reqVar) {
    //       reqObj.variantId = reqVar?.variantId;
    //       reqObj.variantName = reqVar?.variantName;
    //       reqObj.variant = reqVar?.variantId;
    //     }
    //   }
    // }
    // setDiagValues(reqObj);
    // setModVisible(true);
    // setEditModal(true);
  };

  const onCloseDownMod = () => {
    setPrintModVsble(false);
    setSelectedItem(null);
  };

  return (
    <>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <div className="cardWHeader br8 mt15 mh10">
          <div className="bg-body fs13 bdrBtm pt10 pb10 pl15 pr15">
            <Typography className="fs13 txt-semi-bold clr-dark-gray">
              Diagnostics
            </Typography>
          </div>
          <div className="flex-row-wrap1 p15" style={{ gap: "12px" }}>
            {getDiagList()?.length > 0 ? (
              getDiagList()
                ?.slice(0, 5)
                ?.map((li) => {
                  const isApnt = li?.appoinment?.appointmentId ? true : false;
                  const isFutureDue =
                    new Date(li?.dueDate) >
                    new Date(new Date().setHours(0, 0, 0, 0));
                  const isCompleted = li?.status?.toLowerCase() === "completed";
                  const statusLabel = isApnt
                    ? li?.status
                    : isFutureDue
                      ? li?.status
                      : "Overdue";

                  return (
                    <div
                      key={li?.diagonosticId}
                      className="br8 light-blue-back flex-column p15"
                      style={{
                        border: "1px solid #e2e8f0",
                        flex: "1 1 calc(25% - 12px)",
                        minWidth: "180px",
                        maxWidth: "calc(15% - 9px)",
                        boxSizing: "border-box",
                      }}
                    >
                      <Tooltip title={li?.testName || ""}>
                        <Typography
                          className="txt-semi-bold black2 fs12 capitalize"
                          sx={{
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            wordBreak: "break-word",
                          }}
                        >
                          {li?.testName}
                        </Typography>
                      </Tooltip>
                      {/* <Typography className="txt-semi-bold black2 fs12">
                        {li?.testName}
                      </Typography> */}

                      <Typography className="txt-semi-bold fs10 mt10 card-gray-color">
                        Date: {moment(li?.dueDate).format("DD MMM YYYY")}
                      </Typography>

                      <Typography
                        className={`txt-semi-bold fs12 mt10 ph10pv3 br5 width-fit-con ${
                          isCompleted
                            ? "green3 green-back3"
                            : isApnt || isFutureDue
                              ? "orange3 orange-back"
                              : "red3 red-back6"
                        }`}
                      >
                        {statusLabel}
                      </Typography>
                      {canManageDashboard ? (
                        <Typography
                          className="blue-color fs12 txt-semi-bold underline cursor mt10"
                          onClick={() => handleEditModal(li)}
                        >
                          View
                        </Typography>
                      ) : null}
                    </div>
                  );
                })
            ) : (
              <div className="no-rec h50">No records available</div>
            )}
          </div>
        </div>

        {/* <div className="flex-row-ali-cen mt20">
          <Typography className="font-bold fs14">Diagnostics</Typography>
        </div>
        <div className="flex-row-wrap1">
          {getDiagList()?.length > 0 ? (
            getDiagList()
              ?.slice(0, 5)
              ?.map((li, i) => {
                const isApnt = li?.appoinment?.appointmentId ? true : false;
                return (
                  <div
                    key={li?.diagonosticId}
                    className="w30Per flex-column pl10 mt10"
                    style={{
                      borderRight:
                        i !== getDiagList()?.slice(0, 5)?.length - 1
                          ? "1px solid #ddd"
                          : "none",
                    }}
                  >
                    <Typography className="txt-semi-bold black2 fs12 mt10">
                      {li?.testName}
                    </Typography>

                    <div className="flex-row-ali-cen mt10">
                      <div className="gray-dot2" />
                      <Typography className="txt-semi-bold fs10 ml5 orange2">
                        Date: {moment(li?.dueDate).format("DD MMM YYYY")}
                      </Typography>
                    </div>

                    <Typography
                      className={`txt-semi-bold fs12 mt10 ph10pv3 br5 width-fit-con ${
                        li?.status?.toLowerCase() === "completed"
                          ? "green3 green-back3"
                          : isApnt ||
                              new Date(li?.dueDate) >
                                new Date(new Date().setHours(0, 0, 0, 0))
                            ? "orange3 orange-back"
                            : "red3 red-back6"
                      }`}
                    >
                      {isApnt
                        ? li?.status
                        : new Date(li?.dueDate) >
                            new Date(new Date().setHours(0, 0, 0, 0))
                          ? li?.status
                          : "Overdue"}
                    </Typography>
                    <Typography
                      className="blue-color fs12 txt-semi-bold underline cursor mt10"
                      onClick={() => handleEditModal(li)}
                    >
                      View
                    </Typography>
                  </div>
                );
              })
          ) : (
            <div className="no-rec h50">No records available</div>
          )}
        </div> */}
      </Grid>

      <DiagnosticAddUpdate
        modVisible={modVisible}
        handleModClose={handleModClose}
        selectedItem={selectedItem}
      />

      <DiagnosticReport
        reportDownVsble={printModVsble}
        onCloseDownMod={onCloseDownMod}
        selectedItem={selectedItem}
      />

      {/* <CustomModal
        open={modVisible}
        onClose={handleModClose}
        header={isEditModal ? "Edit" : "Add"}
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh">
          <Grid container spacing={2} className="ph20">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mt15">
              <CustomSelect
                list={diagnosticTypes}
                value={diagValues?.type}
                error={diagnosticsErrors?.type}
                helperText={diagnosticsHelpers?.type}
                name="type"
                label={nameExpan?.["type"]}
                select
                handleChange={(e) => {
                  handleChangeValues("type", e?.target?.value);
                }}
                disabled={isEditModal}
                mandatoryField
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomSelect
                list={getDiagnostics()}
                value={diagValues?.testName}
                name="testName"
                label={nameExpan?.["testName"]}
                newSelect
                handleChange={(e) => {
                  handleChangeValues("testName", e?.value, {
                    price: e?.servicePrice ?? 0,
                    tax: e?.tax ?? 0,
                    serviceId: e?.serviceId ?? null,
                    doneAt: e?.doneAt,
                  });
                }}
                error={diagnosticsErrors?.testName}
                helperText={diagnosticsHelpers?.testName}
                disabled={isEditModal}
                mandatoryField
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomSelect
                list={getVariantsByServiceId(diagValues?.serviceId ?? null)}
                value={diagValues?.variant}
                name="variant"
                label={nameExpan?.["variant"]}
                newSelect
                handleChange={(e) => {
                  handleChangeValues("variant", e?.value, {
                    variantName: e?.variantName,
                    variantId: e?.value,
                  });
                }}
                error={diagnosticsErrors?.variant}
                helperText={diagnosticsHelpers?.variant}
                disabled={isEditModal}
                // mandatoryField
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="font-medium fs14 gray7">
                Due Date <span className="red-color">*</span>
              </div>
              <CustomTextField
                name="dueDate"
                fullWidth
                handleChange={(e) =>
                  handleChangeValues("dueDate", e?.target?.value)
                }
                value={diagValues?.dueDate}
                error={diagnosticsErrors?.dueDate}
                helperText={diagnosticsHelpers?.dueDate}
                mobileDate
                disabled={
                  selectedItem?.sampleCollected === "Y" ||
                  diagValues?.sampleCollected
                }
              />
            </Grid>
            {diagValues?.type === "Laboratory Test" && (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="font-medium fs14 gray7">
                  {nameExpan?.["sampleType"]}
                </div>
                <CustomTextField
                  value={getServiceDetById(diagValues?.serviceId)?.sampleType}
                  fullWidth
                  disabled
                />
              </Grid>
            )}
            {diagValues?.type === "Radiology Test" && (
              <>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="font-medium fs14 gray7">
                    {nameExpan?.["modality"]}
                  </div>
                  <CustomTextField
                    value={getServiceDetById(diagValues?.serviceId)?.modality}
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="font-medium fs14 gray7">
                    {nameExpan?.["device"]}
                  </div>
                  <CustomTextField
                    value={getServiceDetById(diagValues?.serviceId)?.device}
                    fullWidth
                    disabled
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mt15">
              <CustomSelect
                list={doneAtList}
                value={diagValues?.doneAt}
                error={diagnosticsErrors?.doneAt}
                helperText={diagnosticsHelpers?.doneAt}
                name="doneAt"
                label={nameExpan?.["doneAt"]}
                select
                handleChange={(e) => {
                  handleChangeValues("doneAt", e?.target?.value);
                }}
                disabled={selectedItem?.sampleCollected === "Y"}
                mandatoryField
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="font-medium fs14 gray7">
                {nameExpan?.["processingTime"]}
              </div>
              <CustomTextField
                value={
                  getServiceDetById(
                    diagValues?.serviceId,
                    diagValues?.variantId ?? null,
                  )?.estimatedDuration ?? ""
                }
                fullWidth
                disabled
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="mtMin10"
            >
              <CustomCheckbox
                label="Study Performed"
                checked={diagValues?.sampleCollected}
                onChange={() =>
                  handleChangeValues(
                    "sampleCollected",
                    !diagValues?.sampleCollected,
                  )
                }
                disabled={selectedItem?.sampleCollected === "Y"}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomSelect
                list={priorityList}
                value={diagValues?.priority}
                error={diagnosticsErrors?.priority}
                helperText={diagnosticsHelpers?.priority}
                name="priority"
                label={nameExpan?.["priority"]}
                select
                handleChange={(e) => {
                  handleChangeValues("priority", e?.target?.value);
                }}
                disabled={isEditModal}
                mandatoryField
              />
            </Grid>
            {diagValues?.sampleCollected && (
              <>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="mt10"
                >
                  <CustomTextField
                    name="collectionTime"
                    fullWidth
                    mobileTime
                    handleChange={(e) =>
                      handleChangeValues("collectionTime", e?.target?.value)
                    }
                    value={diagValues?.collectionTime}
                    error={diagnosticsErrors?.collectionTime}
                    helperText={diagnosticsHelpers?.collectionTime}
                    is12HourFomat={false}
                    label={nameExpan["collectionTime"]}
                    disabled={selectedItem?.sampleCollected === "Y"}
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomTextField
                label={nameExpan?.["remarks"]}
                placeholder="Remarks"
                name="remarks"
                fullWidth
                handleChange={(e) =>
                  handleChangeValues("remarks", e?.target?.value)
                }
                value={diagValues?.remarks}
                error={diagnosticsErrors?.remarks}
                helperText={diagnosticsHelpers?.remarks}
                multiline
                disabled={selectedItem?.status?.toLowerCase() === "completed"}
              />
            </Grid>

            {diagValues?.files?.length > 0 ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <FilesWithCloseButton
                  files={diagValues?.files}
                  onClickFile={(i, file) => handleImageRemove(i)}
                  // disabled={selectedItem?.sampleCollected === "Y"}
                  disabled={selectedItem?.status?.toLowerCase() === "completed"}
                />
              </Grid>
            ) : null}

            {fileError ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <FormHelperText error>File is required</FormHelperText>
              </Grid>
            ) : null}
            {diagValues?.sampleCollected ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <CustomUpload
                  onUploadFile={onUploadFile}
                  multipleNew
                  multiFiles
                  // disabled={selectedItem?.sampleCollected === "Y"}
                  disabled={selectedItem?.status?.toLowerCase() === "completed"}
                />
              </Grid>
            ) : null}

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex1-center">
                <div>
                  <CustomButton
                    text={
                      selectedItem?.status?.toLowerCase() ===
                        "pending review" && role === "ROLE_DOCTOR"
                        ? "Reviewed"
                        : "Submit"
                    }
                    smallBtn
                    disabled={
                      selectedItem?.status?.toLowerCase() === "completed"
                      // ||
                      // (selectedItem?.status?.toLowerCase() ===
                      //   "pending review" &&
                      //   role !== "ROLE_DOCTOR")
                    }
                    grayBtn={
                      selectedItem?.status?.toLowerCase() === "completed"
                      // ||
                      // (selectedItem?.status?.toLowerCase() ===
                      //   "pending review" &&
                      //   role !== "ROLE_DOCTOR")
                    }
                    onClick={handleSave}
                  />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal> */}
    </>
  );
};

export default OverviewDiagnostics;
